import React, { useEffect } from 'react';
import { tumblrAPI } from '../services/api';

export default function TumblrOAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    const errorDescription = params.get('error_description');
    let clientId = null;
    // Try to get client_id from state param (if present)
    try {
      const state = params.get('state');
      if (state) {
        const stateObj = JSON.parse(state);
        clientId = stateObj.client_id;
      }
    } catch {}

    const finish = () => {
      if (window.opener) {
        window.opener.postMessage({ type: 'tumblr_connected' }, '*');
        window.close();
      } else {
        setTimeout(() => {
          window.close();
          window.location.href = '/clients';
        }, 1500);
      }
    };

    const handleError = (errorMsg) => {
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'tumblr_error',
            error: errorMsg,
          },
          '*'
        );
        window.close();
      } else {
        setTimeout(() => {
          window.close();
          window.location.href = '/';
        }, 1500);
      }
    };

    if (error) {
      handleError(errorDescription || error);
      return;
    }

    if (!code) {
      handleError('No authorization code received');
      return;
    }

    if (!clientId) {
      handleError('No client ID found in state parameter');
      return;
    }

    // Exchange code for access token
    tumblrAPI
      .exchangeTumblrCode(code, clientId)
      .then((data) => {
        console.log('Tumblr connection successful:', data);
        finish();
      })
      .catch((error) => {
        console.error('Tumblr connection failed:', error);
        handleError(error.message || 'Failed to connect Tumblr account');
      });
  }, []);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Connecting to Tumblr...</h2>
      <p>Please wait while we complete the connection.</p>
    </div>
  );
}
